/**
 * ESLint rule to prevent empty string values in SelectItem components
 *
 * This rule prevents the common Radix UI Select error where empty strings are
 * used as values, which causes runtime errors since empty strings are
 * reserved for clearing selections.
 */

export default {
  meta: {
    type: "problem",
    docs: {
      description: "Disallow empty string values in SelectItem components",
      category: "Possible Errors",
    },
    fixable: null,
    schema: [],
    messages: {
      emptyValue:
        "SelectItem cannot have an empty string value. Use a placeholder like 'all', 'none', or 'clear' instead. Empty strings are reserved by Radix UI for clearing selections.",
    },
  },
  create(context) {
    return {
      JSXElement(node) {
        // Check if this is a SelectItem component
        if (
          node.openingElement.name.type === "JSXIdentifier" &&
          node.openingElement.name.name === "SelectItem"
        ) {
          // Find the value attribute
          const valueAttr = node.openingElement.attributes.find(
            (attr) => attr.type === "JSXAttribute" && attr.name.name === "value"
          );

          if (valueAttr && valueAttr.value) {
            // Check for empty string literal
            if (
              valueAttr.value.type === "Literal" &&
              valueAttr.value.value === ""
            ) {
              context.report({
                node: valueAttr,
                messageId: "emptyValue",
              });
            }

            // Check for empty string in JSX expression
            if (
              valueAttr.value.type === "JSXExpressionContainer" &&
              valueAttr.value.expression.type === "Literal" &&
              valueAttr.value.expression.value === ""
            ) {
              context.report({
                node: valueAttr,
                messageId: "emptyValue",
              });
            }

            // Check for variables that might be empty strings
            if (
              valueAttr.value.type === "JSXExpressionContainer" &&
              valueAttr.value.expression.type === "Identifier"
            ) {
              const sourceCode = context.getSourceCode();
              const scope = sourceCode.getScope(node);
              const variable = scope.variables.find(
                (v) => v.name === valueAttr.value.expression.name
              );

              if (variable && variable.defs.length > 0) {
                const def = variable.defs[0];
                if (
                  def.node.type === "VariableDeclarator" &&
                  def.node.init &&
                  def.node.init.type === "Literal" &&
                  def.node.init.value === ""
                ) {
                  context.report({
                    node: valueAttr,
                    messageId: "emptyValue",
                  });
                }
              }
            }
          }
        }
      },
    };
  },
};
